import config from "./index";

async function fetchDashboard() {
  const response = await fetch(`${config.apiUrl}/v1/dashboard`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authentication-Token": config.getToken(),
    },
  });
  const data = await response.json();
  return data;
}

export default {
  fetchDashboard,
};
